import React from "react";
export const chess_rules_cutout = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="rect910"
            d="M.306.367v24h24v-24Zm13.151.762c.242-.01.441.342.708,1.08a4.715,4.715,0,0,0,2.071,2.2,10.466,10.466,0,0,1,4.333,5.056,23.954,23.954,0,0,1,.484,5.905,45.425,45.425,0,0,0,.286,5.737l.271,1.247H13.591c-7.47,0-8.019-.041-8.019-.593,0-2.2,2.064-6.391,3.147-6.391a1.96,1.96,0,0,0,1.01-.665,2.358,2.358,0,0,1,1.565-.665,4.312,4.312,0,0,0,4.242-3.952l-.014-1.2-.735,1.476C13.7,12.551,12.647,13.179,10,13.222c-2.051.033-2.272.11-3.082,1.081l-.873,1.045-1.276-.77-1.276-.77.765-.536c.687-.481.706-.559.187-.758a.973.973,0,0,0-.955.155c-.7.7-.909.382-.909-1.394V9.5L4.868,7.94a37.652,37.652,0,0,0,3.093-2.31,22.981,22.981,0,0,1,2.507-1.838A9.412,9.412,0,0,0,12.7,1.886c.322-.492.552-.749.752-.758Z"
            transform="translate(-0.306 -0.367)"
        />
    </svg>
);
